import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import { Stack } from '@mui/material';
import RecipeCard from '../components/RecipeCard';
import { useGetRequestUrl } from '../hooks/useGetRequestUrl';
import ShimmerCard from '../components/ShimmerCard';

export default function Home() {
  const requestUrl = useGetRequestUrl();
  const [cookies, _] = useCookies(['access_token']);
  const [recipes, setRecipes] = useState([]);
  useEffect(() => {
    const getRecipes = async () => {
      const response = await axios.get(
        `${requestUrl}/recipe/`,
        // {
        //   headers: { authorization: `Bearer ${cookies.access_token}` },
        // },
        { headers: { 'Content-Type': 'application/json' } },
        { withCredentials: false }
      );
      console.log(response.data);
      setRecipes(response.data);
    };

    setTimeout(() => {
      getRecipes();
    }, 500);
  }, [recipes, requestUrl]);
  if (recipes.length === 0) {
    return <ShimmerCard />;
  }
  return (
    <Stack
      ml={{ xs: '0px', sm: '0px', md: '88px', lg: '88px' }}
      mr={{ xs: '0px', sm: '0px', md: '88px', lg: '88px' }}
      pb="40px"
      justifyContent="center"
    >
      <Stack
        direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
        justifyContent={{
          xs: 'center',
          sm: 'center',
          md: 'flex-start',
          lg: 'flex-start',
        }}
        flexWrap="wrap"
        alignItems="center"
        gap={2}
        mt={{ xs: '10px', sm: '10px', md: '20px', lg: '60px' }}
      >
        {recipes.map((recipe) => (
          <RecipeCard recipe={recipe} key={recipe._id} />
        ))}
      </Stack>
    </Stack>
  );
}
